<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header :title="getTitle" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
				<div class="common-btn btn" slot="right" @click="onDelete" v-if="!isAddMode">删除</div>
            </mt-header>
        </div>
        <div class="main-content">
            <div v-if="!isAddMode">
				<flex-line :show-border="true"><span class="line-name">配送员账号</span><span slot="right">{{distributor.o2o_distributor_name}}</span></flex-line>
				<flex-line :show-border="true"><span class="line-name">配送员星级</span><span slot="right">{{distributor.o2o_distributor_score}}</span></flex-line>
				<flex-line :show-border="true"><span class="line-name">总订单</span><span slot="right">{{distributor.o2o_distributor_total_count}}</span></flex-line>
				<flex-line :show-border="true"><span class="line-name">总用时</span><span slot="right">{{distributor.o2o_distributor_total_time}}</span></flex-line>
				<flex-line :show-border="true"><span class="line-name">平均用时</span><span slot="right">{{distributor.o2o_distributor_average_time}}</span></flex-line>
            </div>
			<flex-line v-else class="field-line" :show-border="true"><span class="field-name">配送员账号</span><div class="field-line-right" slot="right"><input class="field-input" v-model="distributor.o2o_distributor_name" /></div></flex-line>
			<flex-line class="field-line" :show-border="true"><span class="field-name">配送员密码</span><div class="field-line-right" slot="right"><input class="field-input" type="password" v-model="distributor.o2o_distributor_password" /></div></flex-line>
			<flex-line class="field-line" :show-border="true"><span class="field-name">配送员姓名</span><div class="field-line-right" slot="right"><input class="field-input" v-model="distributor.o2o_distributor_realname" /></div></flex-line>
			<flex-line class="field-line" :show-border="true"><span class="field-name">手机号</span><div class="field-line-right" slot="right"><input class="field-input" v-model="distributor.o2o_distributor_phone" /></div></flex-line>
			<flex-line class="field-line" :show-border="true"><span class="field-name">邮箱</span><div class="field-line-right" slot="right"><input class="field-input" v-model="distributor.o2o_distributor_email" /></div></flex-line>
			<flex-line class="field-line" :show-border="true"><span class="field-name">介绍</span><div class="field-line-right" slot="right"><input class="field-input" type="textarea" v-model="distributor.o2o_distributor_introduce" /></div></flex-line>
			<flex-line class="field-line" :show-border="true"><span class="field-name">备注</span><div class="field-line-right" slot="right"><input class="field-input" type="textarea" v-model="distributor.o2o_distributor_remark" /></div></flex-line>
			<div class="common-btn ds-button-large mt-10 mb-10" @click="submit">提交</div>
        </div>
    </div>
</template>

<script>
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { getDistributorInfo, delDistributor, addDistributor, editDistributor } from '../../../api/sellerO2o'
import flexLine from '../../flexLine'
export default {
  name: 'DistributorForm',
  components: {
  	flexLine
  },
  data () {
    return {
      o2o_distributor_id: 0,
      distributor: {
        'o2o_distributor_name': '',
        'o2o_distributor_realname': '',
        'o2o_distributor_phone': '',
        'o2o_distributor_email': '',
        'o2o_distributor_remark': '',
        'o2o_distributor_introduce': '',
        'o2o_distributor_state': '',
        'o2o_distributor_avatar': ''
      }
    }
  },
  created: function () {
    if (!this.isAddMode) {
      this.o2o_distributor_id = this.$route.query.o2o_distributor_id
      getDistributorInfo(this.o2o_distributor_id).then(res => {
        this.distributor = res.result.info
        this.distributor.o2o_distributor_password = ''
      }).catch(function (error) {
        Toast(error.message)
      })
    }
  },
  computed: {
    isAddMode () {
      let mode = this.$route.query.action
      // add: 添加配送员，edit: 编辑配送员
      if (mode === 'add') {
        return true
      } else {
        return false
      }
    },
    getTitle () {
      if (this.isAddMode) {
        return '新增配送员'
      } else {
        return '修改配送员'
      }
    }
  },
  methods: {
    onDelete () {
      MessageBox.confirm('确定要删除该配送员吗？').then(action => {
        delDistributor(this.o2o_distributor_id).then(
          (response) => {
            this.$router.push({ name: 'SellerO2ODistributor' })
          }, (error) => {
            Toast(error.message)
          })
      })
    },
    submit () {
      if (this.isAddMode) {
        Indicator.open()
        addDistributor(this.distributor).then(
          (response) => {
            Indicator.close()
            Toast(response.message)
            this.$router.push({ name: 'SellerO2ODistributor' })
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      } else {
        Indicator.open()
        editDistributor(this.distributor, this.o2o_distributor_id).then(
          (response) => {
            Indicator.close()
            Toast(response.message)
          }, (error) => {
            Indicator.close()
            Toast(error.message)
          })
      }
    }
  }

}
</script>

<style scoped lang="scss">
.common-header{
	.btn{background: #000;color: #fff;box-shadow: 0px 2px 4px #d2d2d2;}
}
.main-content{background: #fff;padding:0 $pageSpace}
</style>
